import type { SubscriptionPlanDto } from '@peach/types/subscriptions/subscription.dto.js';
import { SUBSCRIPTION_PERIOD_WEEKS, planName } from '@peach/types/subscriptions/types.js';
import { formatPrice } from '@/lib/utils/format';

export { planName };

/** What a plan gives, in one line: "60 min calls, 4 every 4 weeks". */
export function planLine(plan: SubscriptionPlanDto): string {
  if (plan.callsPerWeek === 0) return `Posts and a ${plan.callMinutes} min welcome call`;
  const calls = plan.callsPerWeek * SUBSCRIPTION_PERIOD_WEEKS;
  return `${plan.callMinutes} min calls, ${calls} every ${SUBSCRIPTION_PERIOD_WEEKS} weeks`;
}

export function planPrice(plan: SubscriptionPlanDto): string {
  return formatPrice({ amount: plan.price, currency: plan.currency });
}

export function planTotal(plan: SubscriptionPlanDto): string {
  return formatPrice({ amount: plan.price + plan.platformFee, currency: plan.currency });
}
